/* ---------------------
 * COLORS
 * -------------------- */
export const colorWhite = '#ffffff';
export const colorExtraLight = '#f7f7f7';
export const colorLight = '#ededed';
export const colorLightMedium = '#e0e0e0';
export const colorGrey = '#aeaeae';
export const colorMedium = '#898989';
export const colorDark = '#4f4f4f';
export const colorGreen = '#87bf47';
export const colorGreenMedium = '#64cd7b';
export const colorExtraDark = '#1a1a1a';
export const colorYellow = '#FF6900';
export const colorRed = '#f54739';
export const colorLightRed = '#f15855';
export const colorLightBlue = '#D9E7F4';
export const colorOrangeVisible = '#d27200';
